import React ,{ Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {Table,Grid,Dropdown,Button,Step,Icon,Image,Menu,Pagination,Dimmer,Loader,Checkbox,Header,Message,Select,Input,Breadcrumb,Form,Label} from 'semantic-ui-react'
import SideLeftUncoverIngredients from './SidebarIngredients';
import {ingredientsActions,paymentActions,alertActions, recipesActions,supplierActions} from '../_actions';
import {history,toaster_dispatch,toaster_error, trim,isWeight, isQuantity,isFloat,isNumeric,isEmpty,isInteger} from '../_helpers';
import {  VATValues,VAToptions } from '../_helpers';
import {FormattedMessage,injectIntl} from 'react-intl';
import {styles} from './Styles';
import img_performance from '../Assets/performance.png'
import Dropzone from 'react-dropzone';



const ERROR_MESSAGE_TITLE = <FormattedMessage id="scaninvoice.message.error.main.title"
                                            defaultMessage='Submit Error'/>
         
const ERROR_MESSAGE_CONTENT_NAME =  <FormattedMessage id="scaninvoice.message.error.name"
                                            defaultMessage='Name field should be filled'/>
         
const ERROR_MESSAGE_CONTENT_PRICE = <FormattedMessage id="scaninvoice.message.error.price"
                                            defaultMessage='Price field should be numeric'/>
         
const ERROR_MESSAGE_CONTENT_QUANTITY = <FormattedMessage id="scaninvoice.message.error.quantity"
                                            defaultMessage='Quantity field should be filled'/>
         
const ERROR_MESSAGE_CONTENT_UNIT = <FormattedMessage id="scaninvoice.message.error.unit"
                                            defaultMessage='Unit field is not empty'/>

const ERROR_MESSAGE_CONTENT_PACK = <FormattedMessage id="scaninvoice.message.error.pack"
                                            defaultMessage='Pack field is not empty'/>

const options = [
    { key: '10', text: '10', value: 10 },
    { key: '20', text: '20', value: 20 },
    { key: '30', text: '30', value: 30 },
    { key: '50', text: '50', value: 50 },
  ]
 

const optionsInsert = [
                  { key: 1, text: <FormattedMessage id="scaninvoice.options.action.update"
                                                              defaultMessage='update'/>, value: 'update'},
                  { key: 2, text: <FormattedMessage id="scaninvoice.options.action.create"
                                                              defaultMessage='create'/>, value: 'create'},
                  /* { key: 3, text: <FormattedMessage id="scaninvoice.options.action.ignore"
                                                              defaultMessage='IGNORE'/>, value: 'ignore'} */]

const optionsInsertAltCreate = [
                  { key: 1, text: <FormattedMessage id="scaninvoice.options.action.create"
                                                              defaultMessage='create'/>, value: 'create'},
                  /* { key: 2, text: <FormattedMessage id="scaninvoice.options.action.ignore"
                                                              defaultMessage='IGNORE'/>, value: 'ignore'} */]   
 
class ScanInvoice extends Component {
    constructor(props) {
      super(props);
      this.state = {
        csvfile: undefined,
        rejectedfile: undefined,
        listdata: null,
        isWithCol: true,
        isWithStock: true,
        submitted: false,
        page: 1,
        itemsPerPage: 20,
        stepIndex: 1,
        verified: false,
        text:"",
        scan_items:[],
        selectionList:[],
        supplierSelected : null,
        readyToUpload:0,
        allowMultipleSelection:true,
      }
       
      //this.updateData = this.updateData.bind(this);
      this.onStartExpenseAnalysis = this.onStartExpenseAnalysis.bind(this);
      this.onGetExpenseAnalysis = this.onGetExpenseAnalysis.bind(this);
      this.setPageNum = this.setPageNum.bind(this);
      this.onElemPerPageChange = this.onElemPerPageChange.bind(this);
      props.dispatch(supplierActions.getAll());
      props.dispatch(paymentActions.getCustomerMembership());
      props.dispatch(paymentActions.getSubscriptionState());

    }

    static getDerivedStateFromProps(props, state) {
      if(props.recipes!==state.prevRecipes){
        if (props.recipes.data){
          let result =  {
            prevRecipes : props.recipes,
            //selected: selected,
          }

        let s_items = []
        let numberPages = 0;
        //let t_items= null, t_price= null, t_row= null, t_qty= null,t_price_unit= null,t_unit= null, t_tax=null, t_supplier_code=null, t_product_ean=null
        //let line_confidence = 0;
        //let line_fields_length = 0;
            
/*         if (props.recipes.data.results && props.recipes.data.results.job_status =='SUCCEEDED' 
                    &&  props.recipes.data.results.expenses && props.recipes.data.results.expenses.length > 0) {

            numberPages = props.recipes.data.results.document_metadata.Pages
            props.recipes.data.results.expenses.map((page,idx) => {
                page.line_item_groups.map((line_groups,idx) => {
                    line_groups.line_items.map((line_item,idx) => {
                     
                     line_confidence = 0;
                     line_fields_length = line_item.expense_fields.length
                     line_item.expense_fields.map((field,idx) => {

                            if (field.label==null) field.label="empty"
                            field.value = field.value.replace(',','.') 

                            if (field.type == "ITEM")
                                t_items = field.value
                            if (field.type == "PRICE")
                                t_price = field.value
                            if (field.type == "UNIT_PRICE")
                                t_price_unit = field.value
                            if (field.type == "QUANTITY"){
                                t_qty = field.value
                                if ((field.label.toLowerCase().indexOf('quantit')>=0) ||
                                    (field.label.toLowerCase().indexOf('qté')>=0) ||
                                    (field.label.toLowerCase().indexOf('u/')>=0) ||
                                     (field.label.toLowerCase().indexOf('kg')>=0))
                                  {  t_qty = parseFloat(field.value)
                                     t_unit =  field.value.replace(/[^a-zA-Z]+/g, '');
                                  }
                            }
                            if (field.type == "PRODUCT_CODE"){
                                if ((field.label.toLowerCase().indexOf('code')>=0) ||
                                  (field.label.toLowerCase().indexOf('ref')>=0) ||
                                  (field.label.toLowerCase().indexOf('réf')>=0))
                                {
                                    t_supplier_code = field.value
                                 }
                                if (field.label.toLowerCase().indexOf('ean')>=0){
                                    t_product_ean = field.value
                                 }
                            }
                               
                            if (field.type == "OTHER"){
                                if ((field.label.toLowerCase().indexOf('unit')>=0) ||
                                    (field.label.toLowerCase().indexOf('uv')>=0) ||
                                    (field.label.toLowerCase().indexOf('u/')>=0) ||
                                    (field.label.toLowerCase().indexOf('kg')>=0)
                                                )
                                {
                                   let hasNumbers = /\d/.test(field.value);
                                   if (hasNumbers){
                                      t_qty = parseFloat(field.value)
                                      t_unit =  field.value.replace(/[^a-zA-Z]+/g, '');
                                    } else{
                                        t_unit = field.value
                                    } 
                                }

                                if ((field.label.toLowerCase().indexOf('tva')>=0) ||
                                    (field.label.toLowerCase().indexOf('tax')>=0))
                                t_tax = field.value

                                if ((field.label.toLowerCase().indexOf('quantit')>=0) ||
                                    (field.label.toLowerCase().indexOf('qté')>=0) )
                                  {       
                                     t_qty = parseFloat(field.value)
                                     t_unit =  field.value.replace(/[^a-zA-Z]+/g, '');
                                  }
                                 if (field.label.toLowerCase().indexOf('ean')>=0){
                                     t_product_ean = field.value
                                 }
                            }
                            if (field.type == "EXPENSE_ROW")
                                t_row = field.value
                            
                            line_confidence += field.confidence

                         });

                    line_confidence/=line_fields_length
                    let line ={item: '', quantity:'', unit: 'u', price_unit: '',price: '',tax:'', expense_row:'', supplier_code:'', product_ean:'',confidence:Number(line_confidence).toFixed(1) , valid:0}

                    if (t_items){
                        line.item = t_items
                    }
                    if (t_price){
                         line.price=t_price
                    }
                    if (t_row){
                        line.expense_row=t_row
                    }
                    if (t_qty){
                        line.quantity=t_qty
                    }
                    if (t_unit){
                        line.unit=t_unit
                    }
                   if (t_tax){
                        line.tax=t_tax
                    }
                    if (t_price_unit){
                        line.price_unit=t_price_unit
                    }
                    if (t_supplier_code){
                        line.supplier_code=t_supplier_code
                    }
                    if (t_product_ean){
                        line.product_ean=t_product_ean
                    }

                    s_items.push(line);
                    t_items= null, t_price= null, t_row= null, t_qty= null,t_price_unit= null,t_unit= null, t_tax=null, t_supplier_code=null, t_product_ean=null
                    });
            });
         });  */

        if (props.recipes.data.results && 
            props.recipes.data.results.length > 0  && 
            props.recipes.data.status =='SUCCEEDED'){

            numberPages = props.recipes.data.page_count
            props.recipes.data.results.map((line,idx) => {

                        let tax = Number(line.scanned.tax)
                        //console.log(tax)
                        let tax_allowed = 0.0
                        if (Math.trunc(tax).toString().length<4)
                        {
                             let result = VATValues.find(item => item === tax);
                            if (!result){
                                result = VATValues.reduce((prev, curr) => Math.abs(curr - tax) < Math.abs(prev - tax) ? curr : prev)
                            }
                            //console.log(result)
                            tax_allowed = Number(result/100)
                        }

                        let showline ={ id: idx,
                                        item: line.scanned.raw_name,
                                        quantity:line.scanned.quantity, 
                                        unit: line.scanned.unit, 
                                        price: line.scanned.price,
                                        pack_units : line.scanned.pack_units,
                                        //price_unit: line.scanned.price_unit,
                                        tax: tax_allowed,
                                        expense_row: line.scanned.row, 
                                        supplier_code: line.scanned.supplier_code, 
                                        product_ean: line.scanned.product_ean,
                                        status: line.status,
                                        match: line.database_match,
                                        alternate: line.suggested_alternatives,
                                        confidence: line.scanned.confidence,
                                        user_choice: line.status,
                                        add_to_stock: false,
                                    }
                        s_items.push(showline);                   
            });

         //Set line validity based on fields consistency
         let selection =[]
         s_items.map((line,idx) => {
                let item_valid = 0
                let quantity_valid = 0
                let price_valid = 0
                let unit_valid= 0

                if ((line.item!= "") 
                    && (!isEmpty(line.item))
                    &&(trim(line.item).length>0)){
                    item_valid = 1
                }

                if (line.quantity!= "") {
                let quantity = line.quantity
                if ( (isFloat(quantity) || isNumeric(quantity))
                        && (quantity != "")
                        && (!isEmpty(quantity))
                        && (Math.trunc(quantity).toString().length<10)){
                        quantity_valid = 1}
                }

                if (line.price!= "") {
                let price = line.price
                if ( (isFloat(price) || isNumeric(price))
                        && (price != "")
                        && (!isEmpty(price))
                        && (Math.trunc(price).toString().length<7)){
                        price_valid = 1}
                    }

                if (line.unit!= "") {
                let unit =trim(line.unit).replace(/,/g, '.')
                let isAlphabetic = /^[A-Za-z]+$/.test(unit);
                if ( (unit != "")
                        && (!isEmpty(unit))
                        && isAlphabetic
                        && (Math.trunc(unit).toString().length<10)){
                        unit_valid = 1}    
                    }
   
            let validity = item_valid & quantity_valid & price_valid & unit_valid  
            line.valid = validity & line.confidence >= 50

            if(validity) {
                 selection.push(line)
             }
            });
   
        Object.assign(result,{ scan_items:s_items}); 
        Object.assign(result,{ selectionList: selection});
        Object.assign(result,{ documentNumberPages: numberPages});
        Object.assign(result,{ readyToUpload: 0 });
        Object.assign(result,{ allowMultipleSelection: (selection.length>0)?true:false });
        return result;
        }
      }
      }
      return null;
    }

    addExpenseColumns(expenses,withSelection=1){
            const { allowMultipleSelection,isCheckedAllStock,isCheckedAll } = this.state;
            let colsUnique = [<FormattedMessage id="scaninvoice.col.text.action"
                                                defaultMessage='Action [on existing]'/>,
                               <FormattedMessage id="scaninvoice.col.text.code"
                                                defaultMessage='Code'/>,
                                <FormattedMessage id="scaninvoice.col.text.name"
                                                defaultMessage='Name'/>,//'Désignation',
                                 <FormattedMessage id="scaninvoice.col.text.ean"
                                                defaultMessage='EAN'/>,
                                 <FormattedMessage id="scaninvoice.col.text.quantity"
                                                defaultMessage='Quantity'/>,
                                  <FormattedMessage id="scaninvoice.col.text.unit"
                                                defaultMessage='Unit'/>, // 'Unité',
                                <FormattedMessage id="scaninvoice.col.text.pack"
                                                defaultMessage='Pack'/>, // 'Paquet'
                                <FormattedMessage id="scaninvoice.col.text.price"
                                                defaultMessage='Price'/>, // 'Prix TTC'                             
                                 <FormattedMessage id="scaninvoice.col.text.tax"
                                                defaultMessage='Tax'/> , //'Tva',                             
                                <FormattedMessage id="scaninvoice.col.text.insert"
                                                defaultMessage='Insert in stock'/> ]
            return colsUnique.map((key,index) => {
                         if (index == 0){
                               return ( 
                               <Table.HeaderCell textAlign='left'>
                                {allowMultipleSelection && (withSelection===1) &&
                                                      <Input type='checkbox' 
                                                            onChange={(e,data) => this.selectAllSelectList(e,expenses)}
                                                            style={{'transform': 'scale(1.1)'}}
                                                            checked={isCheckedAll}
                                                            />}<span style={{marginLeft:'0.5em'}}>{key}</span>
                                                         
                                </Table.HeaderCell>
                            );
                         }

                         if (index == 9){
                               return ( 
                               <Table.HeaderCell textAlign='center'>
                                {allowMultipleSelection && (withSelection===1) &&
                                                      <Input type='checkbox' 
                                                            onChange={(e,data) => this.selectAllStockList(e,expenses)}
                                                            style={{'transform': 'scale(1.1)'}}
                                                            checked={isCheckedAllStock}
                                                            />} <span style={{marginLeft:'0em'}} >{key}</span><br/>
                                                        
                                </Table.HeaderCell>
                            );
                         }

                         if (index < colsUnique.length){
                            return (
                                <Table.HeaderCell textAlign='center'>
                                    {key}
                                </Table.HeaderCell>
                            );
                         }
              });
    }

    isChecked(line){
        const { selectionList } = this.state;
        return selectionList.includes(line)
    }


    selectAllSelectList(event,items){
        let allList = []
        if (event.target.checked){
            items.map((ingredient,index) => {
                allList.push(ingredient);
            });
        }else{
            this.setState({actionSelected: ""});
        }
        this.setState({ isCheckedAll: event.target.checked});
        this.setState({ selectionList:allList});
        
    }

    selectAllStockList(event, items){
        items.map((ingredient,index) => {
                if (event.target.checked){
                    ingredient.add_to_stock = true
                }else{
                    ingredient.add_to_stock = false
                }
            });
        this.setState({ isCheckedAllStock: event.target.checked});
    }

    addSelectList(event,line){
        const { selectionList } = this.state;
        if (event.target.checked){
            this.setState({ selectionList:[...selectionList,line]});
        }else{
            this.setState({ selectionList:selectionList.filter((item)=> item!=line)});
            if (selectionList.length <= 1){
                this.setState({actionSelected: ""});
            }
            this.setState({isCheckedAll: false});
        }
    }


    addStockList(event,line){
            const updates = this.state.scan_items.map((ingredient, idx) => {
                if (line.id === ingredient.id) {
                    if (event.target.checked){
                      ingredient.add_to_stock = true;
                    }else{
                      ingredient.add_to_stock = false;
                    }
                    return ingredient;
                }else {
                    return ingredient;
                }
            });
                    
            this.setState({ scan_items: updates });
    }

    onActionChange = (event,data,line) => {
        event.preventDefault();
        //console.log(data)
       let scannedList = this.state.scan_items.map((item) => {
                if (item.id == line.id){
                    if (data.value == 'update') 
                    { 
                      if (item.status!='create'){
                         item.user_choice = 'update'
                      }
                    }else if (data.value == 'create')
                    {
                      item.user_choice = 'create'
                    }else{
                      //item.user_choice = 'ignore'
                    }
               }
               return item;
        }); 
       // console.log(scannedList)
        this.setState({ scan_items: scannedList});
    }

/*     extract_matchs =  (row) => {
        console.log('extract_matchs')
        console.log(row)
        return row.map((item) => {
            return(
                   <li style={{'color':'#b5b1b1','font-size':'10px',marginLeft:'0.3em'}}>
                       <i>{item.name.substring(0,30)} </i> 
                   </li>
                );
        });
    } */

      onNameChange = (e,line) => {
            e.preventDefault();
            const updates = this.state.scan_items.map((ingredient, idx) => {
                if (line.id === ingredient.id) {
                    let value = e.target.value;
                    ingredient.item = value;
                    return ingredient;
                }else {
                    return ingredient;
                }
            });
                    
            this.setState({ scan_items: updates });
    }


    onQuantityChange = (e,line) => {
            e.preventDefault();
            const updates = this.state.scan_items.map((ingredient, idx) => {
                 if (line.id === ingredient.id) {
                    let value = e.target.value;
                    ingredient.quantity = value;
                    return ingredient;
                }else {
                    return ingredient;
                }
            });
                    
            this.setState({ scan_items: updates });
    }


    onUnitChange = (e,line) => {
            e.preventDefault();
            const updates = this.state.scan_items.map((ingredient, idx) => {
                 if (line.id === ingredient.id) {
                    let value = e.target.value;
                    ingredient.unit = value;
                    return ingredient;
                }else {
                    return ingredient;
                }
            });
                    
            this.setState({ scan_items: updates });
    }

    onPackUnitsChange = (e,line) => {
            e.preventDefault();
            const updates = this.state.scan_items.map((ingredient, idx) => {
                 if (line.id === ingredient.id) {
                    let value = e.target.value;
                    ingredient.pack_units = value;
                    return ingredient;
                }else {
                    return ingredient;
                }
            });
                    
            this.setState({ scan_items: updates });
    }


    onPriceChange = (e,line) => {
            e.preventDefault();
            const updates = this.state.scan_items.map((ingredient, idx) => {
                 if (line.id === ingredient.id) {
                    let value = e.target.value;
                    ingredient.price = value;
                    return ingredient;
                }else {
                    return ingredient;
                }
            });
                    
            this.setState({ scan_items: updates });
    }

/*     onSupplierCodeChange = (e,index) => {
            e.preventDefault();
            const updates = this.state.scan_items.map((ingredient, idx) => {
                if (index === idx) {
                    let value = e.target.value;
                    ingredient.supplier_code = value;
                    return ingredient;
                }else {
                    return ingredient;
                }
            });
                    
            this.setState({ scan_items: updates });
    } */

/*     onEANChange = (e,index) => {
            e.preventDefault();
            const updates = this.state.scan_items.map((ingredient, idx) => {
                if (index === idx) {
                    let value = e.target.value;
                    ingredient.product_ean = value;
                    return ingredient;
                }else {
                    return ingredient;
                }
            });
                    
            this.setState({ scan_items: updates });
    } */
    
    onTaxChange = (e,data,line) => {
            e.preventDefault();
            //console.log(data.value)
            const updates = this.state.scan_items.map((ingredient, idx) => {
                if (line.id === ingredient.id) {
                    ingredient.tax = data.value;
                    return ingredient;
                }else {
                    return ingredient;
                }
            });        
            this.setState({ scan_items: updates });
    }


    addExpenseRows(items,withSelection=1){
        const {stepIndex} = this.state;
        return items.map((line,idx) => {
                    return (<Table.Row key={idx}>
                                 <Table.Cell textAlign='left'>
                                      <span>
                                        {(withSelection == 1) &&
                                            <Input type='checkbox'
                                                onChange={(e) => this.addSelectList(e,line)}
                                                style={{'transform': 'scale(1.1)'}}
                                                checked={this.isChecked(line)}
                                                //disabled={!line.valid}
                                                /> }
                                        </span>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    { line.valid == 1  && line.user_choice == "update" &&
                                     <span>
                                        { line.match && line.match.name==line.item &&
                                        <Dropdown key={idx}
                                                options={optionsInsert}
                                                value = {line.user_choice}
                                                disabled = {!withSelection}
                                                onChange={(event,data)=>this.onActionChange(event,data,line)}
                                                style={styles.ButtonGreenNoMarginMenuSmall}/>}
                                        {line.match && line.match.name!=line.item &&
                                        <Dropdown key={idx} 
                                                options={optionsInsert}
                                                value = {line.user_choice}
                                                disabled = {!withSelection}
                                                onChange={(event,data)=>this.onActionChange(event,data,line)}
                                                style={styles.ButtonOrangeNoMarginMenuSmall}/>}
                                        {line.match &&  
                                            <span style={{'color':'#b5b1b1','font-size':'11px',marginLeft:'0.2em'}}>
                                                <i>
                                                [ {line.match.name.substring(0,20)}  {line.match.name.length>20 && <span>...</span>} ]
                                                </i>
                                            </span>} 
                                            {/*   {line.match && <span style={{display: 'block;'}}><ul>{this.extract_matchs(line.match)}</ul></span>}    */}
                                    </span>}
                                     {line.valid == 1 &&  line.user_choice == "create" &&
                                     <Dropdown key={idx} 
                                               options={optionsInsert}
                                               value = {line.user_choice}
                                               disabled = {!withSelection}
                                               onChange={(event,data)=>this.onActionChange(event,data,line)}
                                               style={styles.ButtonGreenNoMarginMenuSmall}/>} 
                                    {line.valid == 0 &&
                                    <span>
                                     <Dropdown key={idx} 
                                               options={optionsInsert}
                                               value = {line.user_choice}
                                               //disabled = {true}
                                               disabled = {!withSelection}
                                               onChange={(event,data)=>this.onActionChange(event,data,line)}
                                               style={styles.ButtonRedNoMarginMenuSmall}/>
                                       {line.match &&  line.user_choice == "update" &&
                                            <span style={{'color':'#b5b1b1','font-size':'11px',marginLeft:'0.2em'}}>
                                                <i>
                                                [ {line.match.name.substring(0,20)}  {line.match.name.length>20 && <span>...</span>} ]
                                                </i>
                                            </span>} 
                                    </span>}
                                </Table.Cell>
                                <Table.Cell textAlign='center'>
                                     <span style={{'top': '0.7em', position: 'relative'}}>{line.supplier_code.substring(0,10)}
                                     {line.supplier_code.length>10 && <span>...</span>}
                                     </span>
{/*                                     {line.supplier_code != "" &&
                                            <Input type="text"
                                                   value={line.supplier_code} 
                                                   onChange={(e)=>this.onSupplierCodeChange(e,idx)}
                                                   style={{ width: line.supplier_code.length > 0 ? `${line.supplier_code.length + 4}ch` : '10h' }}   />
                                    } */}
                                </Table.Cell>
                                <Table.Cell textAlign='center'><Input type="text"
                                                   value={line.item} 
                                                   onChange={(e)=>this.onNameChange(e,line)}
                                                   error={!this.assertNameField(line)}
                                                   //style={{ width: line.item.length > 0 ? `${line.item.length + 4}ch` : '10ch' , 'background-color': 'transparent;',background:'transparent;',color:'transparent;'}}   
                                                   disabled = {stepIndex === 3}
                                                   style={{ width:  '40ch',  'max-width':  '50ch'}}
                                                   /></Table.Cell>
                                <Table.Cell textAlign='center'>
                                     <span style={{'top': '0.7em', position: 'relative'}}>{line.product_ean.substring(0,10)}
                                     {line.product_ean.length>10 && <span>...</span>}
                                     </span>
                                    {/*   {line.product_ean != "" &&
                                            <Input type="text"
                                                   value={line.product_ean} 
                                                   onChange={(e)=>this.onEANChange(e,idx)}
                                                   style={{ width: line.product_ean.length > 0 ? `${line.product_ean.length + 4}ch` : '10ch' }}   />
                                    } */}

                                </Table.Cell>
                                <Table.Cell textAlign='right'><Input type="text"
                                                   value={line.quantity} 
                                                   onChange={(e)=>this.onQuantityChange(e,line)}
                                                   error={!this.assertQuantityField(line)}
                                                   disabled = {stepIndex === 3}
                                                   style={{ width:  '10ch' }}  />
                                                   </Table.Cell>
                                <Table.Cell textAlign='right'><Input type="text"
                                                   value={line.unit} 
                                                   onChange={(e)=>this.onUnitChange(e,line)}
                                                   error={!this.assertUnitField(line)}
                                                   disabled = {stepIndex === 3}
                                                   style={{ width:  '8ch' }}
                                                   //style={{ width: line.unit.length > 0 ? `${line.unit.length + 4}ch` : '10ch' }} 
                                                    /></Table.Cell>
                                <Table.Cell textAlign='right'><Input type="text"
                                                   value={line.pack_units} 
                                                   onChange={(e)=>this.onPackUnitsChange(e,line)}
                                                   error={!this.assertPackUnitsField(line)}
                                                   disabled = {stepIndex === 3}
                                                   style={{ width:  '8ch' }}
                                                   //style={{ width: line.unit.length > 0 ? `${line.unit.length + 4}ch` : '10ch' }} 
                                                    /></Table.Cell>
                                <Table.Cell textAlign='right'><Input type="text"
                                                   value={line.price} 
                                                   onChange={(e)=>this.onPriceChange(e,line)} 
                                                   error={!this.assertPriceField(line)}
                                                   disabled = {stepIndex === 3}
                                                   style={{ width:  '10ch' }}
                                                   //style={{ width: line.price.length > 0 ? `${line.price.length + 4}ch` : '10ch' }} 
                                                   /></Table.Cell>
                                <Table.Cell textAlign='right'>
                                    <Select compact
                                            options={VAToptions} 
                                            type="text"
                                            id="VAT"
                                            value={line.tax}
                                            disabled = {stepIndex === 3}
                                            onChange={(e,data)=>this.onTaxChange(e,data,line)} />
                                </Table.Cell>
                                 <Table.Cell textAlign='center'>
                                            <Input type='checkbox'
                                                onChange={(e,data) => this.addStockList(e,line)}
                                                style={{'transform': 'scale(1.0)'}}
                                                checked={line.add_to_stock == true}
                                                disabled={stepIndex === 3}
                                                />
                                </Table.Cell>
                            </Table.Row>);
                    });
    }


   assertAllNameField(){
    let values = [];
    this.state.selectionList.map((ingredient, idx) => {
        if (ingredient &&  (ingredient.item != "")
            &&(trim(ingredient.item).length>0)
            &&(trim(ingredient.item).length<100)){
                values.push(true)
        }else{
            values.push(false)
        }         
    });
    return values.every(v => v===true)
   }

    assertNameField(ingredient){
        if (ingredient && 
              (ingredient.item != "")
                &&(trim(ingredient.item).length>0)
                &&(trim(ingredient.item).length<100))
                    return true
        return false   
    }

    assertAllPriceField(){
       let values = [];
       this.state.selectionList.map((ingredient, idx) => {
           let price = trim(ingredient.price.toString()).replace(/,/g, '.')
           if ((isFloat(price) || isNumeric(price))
               && (ingredient.price != "")
               && Math.trunc(ingredient.price).toString().length<7){
                   values.push(true)
           }else{
               values.push(false)
           }         
       });
       return values.every(v => v===true)
    }

    assertPriceField(ingredient){
        let price = trim(ingredient.price.toString()).replace(/,/g, '.')
           if ((isFloat(price) || isNumeric(price))
               && (ingredient.price != "")
               && Math.trunc(ingredient.price).toString().length<7)
                    return true
        return false   
    }

     assertAllQuantityField(){
        let values = [];
        this.state.selectionList.map((ingredient, idx) => {
            let quantity = trim(ingredient.quantity.toString()).replace(/,/g, '.')
            if ( (isFloat(quantity) || isNumeric(quantity))
                        && (quantity != "")
                        && (!isEmpty(quantity))
                        && (Math.trunc(quantity).toString().length<10)){
                     values.push(true)   
            }else{
                values.push(false)
            }         
        });
        return values.every(v => v===true)
    }

    assertQuantityField(ingredient){
        let quantity =trim(ingredient.quantity.toString()).replace(/,/g, '.')
         if ( (isFloat(quantity) || isNumeric(quantity))
                        && (quantity != "")
                        && (!isEmpty(quantity))
                        && (Math.trunc(quantity).toString().length<10))
            return true
        return false   
    }

    assertUnitField(ingredient){
        let unit = trim(ingredient.unit)
        let isAlphabetic = /^[A-Za-z]+$/.test(unit);
        if ( (unit != "")
             && (!isEmpty(unit))
             && isAlphabetic
             && (Math.trunc(unit).toString().length<10))
            return true
        return false   
    }

    assertAllUnitsField(){
        let values = [];
        this.state.selectionList.map((ingredient, idx) => {
            let unit =trim(ingredient.unit)
            let isAlphabetic = /^[A-Za-z]+$/.test(unit);
            if ( (unit != "")
                && (!isEmpty(unit))
                && isAlphabetic
                && (Math.trunc(unit).toString().length<10)){
                    values.push(true)          
                }else{
                    values.push(false)
                }  
        });
        return values.every(v => v===true)
    }

    assertPackUnitsField(ingredient){
        let pack_units =  Number(ingredient.pack_units)
        if ( (pack_units > 0)
                && isInteger(pack_units)
                && (Math.trunc(pack_units).toString().length<7))
            return true
        return false   
    }

    assertAllPackUnitsField(){
        let values = [];
        this.state.selectionList.map((ingredient, idx) => {
            let pack_units = Number(ingredient.pack_units)
          if ( (pack_units > 0)
                && isInteger(pack_units)
                && (Math.trunc(pack_units).toString().length<7)){
                     values.push(true)   
            }else{
                values.push(false)
            }         
        });
        return values.every(v => v===true)
    }

    assertMandatoryFields(){
         const {intl } = this.props;
        if (!this.assertAllNameField()){
           toaster_error( intl.formatMessage({ id: 'scaninvoice.message.error.main.title' }),
                          intl.formatMessage({ id: 'scaninvoice.message.error.name' }));
          return false;
        }

        if (!this.assertAllPriceField()){
            toaster_error(intl.formatMessage({ id: 'scaninvoice.message.error.main.title' }),
                          intl.formatMessage({ id: 'scaninvoice.message.error.price' }));
            return false;
        }

        if (!this.assertAllQuantityField()){
            toaster_error(intl.formatMessage({ id: 'scaninvoice.message.error.main.title' }),
                          intl.formatMessage({ id: 'scaninvoice.message.error.quantity' }));
            return false;
        }

        if (!this.assertAllUnitsField()){
            toaster_error(intl.formatMessage({ id: 'scaninvoice.message.error.main.title' }),
                          intl.formatMessage({ id: 'scaninvoice.message.error.unit' }));
            return false;
        }
        if (!this.assertAllPackUnitsField()){
            toaster_error(intl.formatMessage({ id: 'scaninvoice.message.error.main.title' }),
                          intl.formatMessage({ id: 'scaninvoice.message.error.pack' }));
            return false;
        }
        return true;
    }


    loadIngredients(e){
        e.preventDefault();
        const {selectionList,supplierSelected} = this.state;
        const {dispatch } = this.props;

        let updates = []
        let creates = []

        dispatch(alertActions.clear());
        this.setState({ submitted: true });

        if (!this.assertMandatoryFields())
            return;

        if (selectionList && selectionList.length>0 && supplierSelected) {
    
            selectionList.map((ingredient, idx) => {    
              let purchase_weight = ""
              let purchase_volume = ""
              let purchase_quantity = ""

            if (isQuantity(trim(ingredient.unit))){
                    purchase_quantity = "" +  ingredient.quantity + ingredient.unit
                    purchase_quantity = trim(purchase_quantity);
              }else if (isWeight(trim(ingredient.unit))){
                    purchase_weight = "" + ingredient.quantity + ingredient.unit
                    purchase_weight = trim(purchase_weight).replace(/,/g, '.');
              }else /*  (isVolume(trim(ingredient.unit)))*/{
                    purchase_volume = "" +  ingredient.quantity + ingredient.unit
                    purchase_volume = trim(purchase_volume).replace(/,/g, '.');
              }

              let ean = ingredient.product_ean

              let ingred_element = {
                name : trim(ingredient.item).substring(0, 99),
                price : Number(trim(ingredient.price.toString()).replace(/,/g, '.')).toFixed(3),
                purchase_quantity: purchase_quantity,
                purchase_volume : purchase_volume,
                purchase_weight : purchase_weight,
                pack_units : ingredient.pack_units,
                supplier : supplierSelected,
                ref_supplier: ingredient.supplier_code,
                note: (ean!="")?'EAN: '+ ingredient.product_ean:"",
                add_to_stock: ingredient.add_to_stock,
              }


              if (ingredient.tax!=''){
                let tax_value = Number(ingredient.tax)
                if ((isFloat(tax_value) || isNumeric(tax_value)) && 
                    (Math.trunc(tax_value).toString().length<4))
                {
                    Object.assign(ingred_element,{ tax : tax_value});   
                }else{
                    Object.assign(ingred_element,{ tax : 0 });   
                }
              } 

              if (ingredient.user_choice == 'update'){
                   //To be checked if multiple matches needed
                   /* let matches = []
                   ingredient.match.map((match,idx) => {
                          matches.push(match.id)
                   }); */
                   Object.assign(ingred_element,{ ingredient_id : ingredient.match.id });
                   Object.assign(ingred_element,{ price_changed : ingredient.match.price_changed });
                   updates.push(ingred_element)
              }
              if (ingredient.user_choice == 'create'){
                   creates.push(ingred_element)
              }

            });    

            this.setState({stepIndex:4});
            console.log({'updates': updates, 'creates':creates})
            dispatch(ingredientsActions.updateAndCreate({'updates': updates, 'creates':creates}));
        }
    }

    setPageNum = (event, { activePage }) => {
        this.setState({ page: activePage });
    };

    onElemPerPageChange = (e,data) => {
        e.preventDefault();
        this.setState({ itemsPerPage: data.value });
    }

    onDropAccepted(acceptedFiles) {
        this.setState({csvfile:acceptedFiles[0]});
        this.setState({readyToUpload:1});        
    }

    onDropRejected(rejectedFiles) {
        const {dispatch} = this.props;
        this.setState({rejectedFile:rejectedFiles[0]});

        dispatch(alertActions.error({title: 'scaninvoice.file.error.title',
                                    content:'scaninvoice.file.size.error.content'}));
    }

    onDeleteFile(e) {
        e.stopPropagation();
        const {recipes} = this.props;
        this.setState({csvfile:undefined});
        //window.location.reload();
        //history.push('/');
        //history.replace('/scaninvoice/', null);
        history.replace("/");
        setTimeout(() => {
                history.replace("/scaninvoice");
        }, 10);
    }

    onStartExpenseAnalysis(e) {
        e.stopPropagation();
        const {csvfile,readyToUpload} = this.state;

        if (csvfile && readyToUpload){
            this.props.dispatch(recipesActions.invoiceParse(csvfile));
        }
        //this.setState({csvfile:undefined});
        this.setState({stepIndex:2});
    }


    onGetExpenseAnalysis(e) {
        e.stopPropagation();
        const {recipes} = this.props;
        //console.log(recipes)
        if (recipes  && recipes.request_done ){
            this.props.dispatch(recipesActions.invoiceGetStatus(recipes.jobid.job_id));
        }
  
    }

    onSelect = (e,index) => {
        e.preventDefault();
       
        this.setState({stepIndex:index});

        if (index < 3){
            this.setState({verified:false});
        }else{
            this.setState({verified:true});
        }
    }

    onValidateStep(e){
        e.preventDefault();
        //Check mandatory fields are consistent
        if (this.assertMandatoryFields()){
           this.setState({stepIndex:3});
           this.setState({verified:true});
        }
    } 

    onCheckboxChange = (e, data) => {
        this.setState({ isWithCol: data.checked});
    }

    onCheckboxStockChange = (e, data) => {
        this.setState({ isWithStock: data.checked});
    }

    upgradeSubscription = () => {
        history.push({pathname: '/profilepremium', state: {toggled: true}})
    }

    isPremiumUser(){
        const { subscription,customer } = this.props;
        let user = null;

        if (customer){
            user = customer.user;
        } 

        if (user && user.bypass === true){
            return true
        } 

        if (subscription && !isEmpty(subscription) && (subscription.active === true  ||  subscription.bypass === true) ){
            return true
        }
        return false
    }

     onSupplierChange = (e,data) => {
        e.preventDefault();
        const {supplier} = this.props;
        if (data.value==""){
            this.setState({ supplierSelected: null });
        }else{
            let supplier_id = data.value;
            let elem = supplier.options.find(supplier => supplier.value == supplier_id)
            this.setState({ supplierSelected: {id:supplier_id,
                                                name: elem.text } });
        }
    }


    render() {
      const {page,itemsPerPage,stepIndex,csvfile,isWithCol,scan_items,supplierSelected,selectionList,documentNumberPages,} = this.state;
      const { alert,dispatch,intl,ingredients,adding,recipes,supplier,customer,loading} = this.props;
      let totalPages = 1;
      let items = [];
      let length = 0;
      let begin = 0;
      let end  = 0;
      //let user = null;
      let membership = null;

      if (customer){
            membership = customer.membership;
            //user = customer.user;
       } 

      //console.log('selectionList = ' , selectionList)
      //console.log('scan_items = ', scan_items)

      if (scan_items && scan_items.length>0 ){
          length = scan_items.length
          totalPages = Math.ceil( length / itemsPerPage);
          begin = (page - 1) * itemsPerPage;
          end = (page - 1) * itemsPerPage + itemsPerPage;
          if (end > length) end=length;
          if (begin > length) begin=0;
          items = scan_items.slice(begin,end);
      }

      console.log('items = ', items)

      let fileName = ''
      if (csvfile){
        fileName = csvfile.name
      }

      let content = csvfile 
      ? ( <span  style={{'font-family': 'Lato','font-size': '16px'}} color='blue'>{fileName} 
                <Icon name='trash alternate outline' color='blue' style={{'cursor': 'pointer'}} onClick={(event)=>this.onDeleteFile(event)}/>
          </span>) 
      : ( <span style={{'font-family': 'Lato','font-size': '16px'}}>
            <FormattedMessage id="scaninvoice.dropzone.text.line1"
                              defaultMessage="Drag 'n' drop your PDF or image file here, or"/>{' '}
                    <a href="#" disabled><FormattedMessage id="scaninvoice.dropzone.text.line2"
                                                  defaultMessage="Click here to select"/></a></span> );
      return (
        <SideLeftUncoverIngredients>
            <div className="App">
                <Grid stackable style={styles.FontLato13Border} >
                   <Grid.Row columns={1}>
                     <Breadcrumb  style={{background:'#fcfcfc'}}>
                            <Breadcrumb.Section link as={Link} to={'/dashboard/'}><FormattedMessage id="scaninvoice.link.dashboard"
                                                                        defaultMessage='Dashboard'/></Breadcrumb.Section>
                            <Breadcrumb.Divider icon='right chevron'/>
                            <Breadcrumb.Section link as={Link} to={'/ingredients/'}><FormattedMessage id="scaninvoice.link.ingredients"
                                                                        defaultMessage='Ingredients'/></Breadcrumb.Section>
                            <Breadcrumb.Divider icon='right chevron'/>
                            <Breadcrumb.Section active><FormattedMessage id="scaninvoice.link.scan"
                                                                         defaultMessage='Scan Invoice'/></Breadcrumb.Section>
                     </Breadcrumb>
                    </Grid.Row>
                    <Grid.Row columns={1} >
                        <Grid.Column width={10}>
                            <Header as='h2' /* color='blue' */>
                                <Header.Content>
                                    <FormattedMessage id="scaninvoice.page.title"
                                      defaultMessage="Scan your Invoice"/>
                                </Header.Content>
                            </Header>
                            </Grid.Column>
                    </Grid.Row>
                    <br/>
                    <Grid.Row columns={1} /*style={{'overflow-x': 'auto'}}*/>
                        <Grid.Column /*width={14}*/  mobile={16} tablet={16} computer={14}> 
                            <Step.Group fluid stackable widths={4}>
                                <Step active={true}  disabled={stepIndex!=1} /*disabled={stepIndex==2 || stepIndex ==3} link={stepIndex==4} href='/scaninvoice'*/>
                                    <Icon name='file pdf outline' color='blue'/>
                                    <Step.Content>
                                        <Step.Title><FormattedMessage id="scaninvoice.step1.title"
                                                                     defaultMessage="Load invoice"/></Step.Title>
                                        <Step.Description><FormattedMessage id="scaninvoice.step1.subtitle"
                                                                            defaultMessage="PDF or image file"/>
                                      </Step.Description>
                                    </Step.Content>
                                </Step>
                                <Step active={true} disabled={stepIndex!=2}>
                                    <Icon name='sync alternate' color='yellow'/>
                                    <Step.Content>
                                        <Step.Title><FormattedMessage id="scaninvoice.step2.title"
                                                                     defaultMessage="Get IA data analysis"/></Step.Title>
                                        <Step.Description><FormattedMessage id="scaninvoice.step2.subtitle"
                                                                     defaultMessage="Check/Modify AI extracted lines"/></Step.Description>
                                    </Step.Content>
                                </Step>
                                <Step active={true} disabled={stepIndex!=3}>
                                    <Icon name='dna' color='orange'/>
                                    <Step.Content>
                                        <Step.Title><FormattedMessage id="scaninvoice.step3.title"
                                                                     defaultMessage="Check your data"/></Step.Title>
                                        <Step.Description><FormattedMessage id="scaninvoice.step3.subtitle"
                                                                     defaultMessage="Before update/insert"/></Step.Description>
                                    </Step.Content>
                                </Step>
                                <Step active={true} disabled={stepIndex!=4}>             
                                    <Icon name='th' color='teal'/>
                                    <Step.Content>
                                        <Step.Title><FormattedMessage id="scaninvoice.step4.title"
                                                                     defaultMessage="Result"/></Step.Title>
                                        <Step.Description><FormattedMessage id="scaninvoice.step4.subtitle"
                                                                     defaultMessage="Import status"/></Step.Description>
                                    </Step.Content>
                                </Step>
                            </Step.Group>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns={1} style={{'padding': '0 0 0 0'}}/>
                    {stepIndex == 0 && <Grid.Row columns={1}>
                        <Grid.Column textAlign='left' mobile={8} tablet={8} computer={12} style={{'paddingLeft': '2.5em'}}>
                           <Message fluid /*style={styles.FontLato13Bold}*/ warning icon >
                                   <Icon name='info circle'/>
                                   <Message.Content>
                                    <Message.Header><FormattedMessage id="scaninvoice.step1.message.header"
                                                              defaultMessage=" This menu is only used to update existing ingredients (no items will be added)."/>
                                    </Message.Header>
                                    <p style={{'font-weight':'bold'}} > <FormattedMessage id="scaninvoice.step1.message.subheader"
                                                                                          defaultMessage="If you need to import or add ingredients, please use side menu"/>
                                                        <Link to={process.env.PUBLIC_URL + '/importingredients'}>{'  '}
                                                                <FormattedMessage id="scaninvoice.step1.message.subheader.link"
                                                                                defaultMessage="Initial import or add"/>
                                                        </Link>
                                    </p>
                                     <Message.List>
                                         <Message.Item>
                                                   <FormattedMessage id="scaninvoice.step1.message.line0"
                                                                     defaultMessage="All ingredients with the exact same name will be updated (Case sensitive)."/>
       
                                        </Message.Item>
                                       {/*  <Message.Item>
                                            <FormattedMessage id="scaninvoice.step1.message.line1"
                                                              defaultMessage="Update is case sensitive, only exact same name will be updated."/>
                                        </Message.Item> */}
                                        <Message.Item>
                                            <FormattedMessage id="scaninvoice.step1.message.line4"
                                                              defaultMessage="If multiple ingredients have the same name, all items will be updated."/>
                                        </Message.Item>
                                        <Message.Item>
                                            <FormattedMessage id="scaninvoice.step1.message.line2"
                                                              defaultMessage="If ingredient unit is changed, all alternative suppliers (if any) will be removed."/>
                                        </Message.Item>
                                        {/* <Message.Item>
                                            <FormattedMessage id="scaninvoice.step1.message.line3"
                                                              defaultMessage="If ingredient unit is the same, all alternative suppliers (if any) will be keeped."/>
                                        </Message.Item> */}
                                    </Message.List>
                                    </Message.Content>
                            </Message>
                            <Header size='small' fluid>
                                  <Icon name='file excel outline'/> 
                                  <Header.Content>
                                         <FormattedMessage id="scaninvoice.template.file.title"
                                                         defaultMessage="Use your initial import file updated"/> {' '}
                                  </Header.Content>
                                  <br/>
                                  <Header.Content> 
                                    <FormattedMessage id="scaninvoice.template.file.column.option"
                                                     defaultMessage='First line is column names'>
                                        { label => 
                                            <Checkbox label={label}
                                                    style={{margin:'0em 0em 0em 2em'}} 
                                                    onChange={this.onCheckboxChange}
                                                    checked={isWithCol}/>
                                        }
                                    </FormattedMessage>
                                  </Header.Content>
                            </Header>
                        </Grid.Column>
                    </Grid.Row>}
                    {/* <Grid.Row columns={1}/> */}
                    {!loading && this.isPremiumUser() && stepIndex == 1 && <Grid.Row columns={2}>
                        <Grid.Column textAlign='left'  mobile={12} tablet={12} computer={10}>
                              <Message /* style={styles.FontLato13Bold} */ info size='large'>
                                    <Icon name='info circle' size='large' color='grey'/>
                                    <FormattedMessage id="scaninvoice.header.text.placeholder"
                                                       defaultMessage='Choose a supplier then select the associated invoice file (pdf or image) to scan'/>   
                            </Message>
                        </Grid.Column>
                    </Grid.Row>}
                      {!loading && this.isPremiumUser() && stepIndex == 1 &&
                      <Grid.Row columns={2}>
                        <Grid.Column textAlign='right'  mobile={16} tablet={16} computer={14}>
                           <Form>
                              <Form.Group>
                               <Form.Field width={1}>
                                    <Icon color='grey' name='shipping fast' style={{margin:'0.6em 0em 0em 0em'}} size='large'/>
                                </Form.Field>
                                <Form.Field width={4}>
                                    <FormattedMessage id="scaninvoice.form.supplier.placeholder"
                                                       defaultMessage='Select a supplier'>
                                        {placeholder =>   
                                                <Form.Dropdown selection search 
                                                        options={supplier && supplier.options} 
                                                        value = {supplierSelected && supplierSelected.id} 
                                                        placeholder={placeholder} 
                                                        onChange={this.onSupplierChange}
                                                        //onFocus={(e)=>this.onFocusElsewhere(e)}
                                                        clearable
                                                        style={{'background-color':'#e8f3fa','font-size': '16px','font-weight': '500','color': 'black'}}
                                                        //style={{minWidth:'10em',maxWidth:'30em'}}
                                                    />}
                                    </FormattedMessage>
                                </Form.Field>
                                <br/>
                                </Form.Group>
{/*                                 <Form.Group>
                                <Form.Field width={4}>
                                     <FormattedMessage id="scaninvoice.template.file.column.option.stock"
                                                     defaultMessage='Add elements to stock'>
                                        { label => 
                                            <Checkbox label={label}
                                                    style={{margin:'0em 0em 0em 2em'}} 
                                                    onChange={this.onCheckboxStockChange}
                                                    checked={isWithStock}/>
                                        }
                                    </FormattedMessage>
                                    </Form.Field>
                                </Form.Group> */}
                            </Form>
                        </Grid.Column>
                    </Grid.Row>}
                    {!loading && this.isPremiumUser() && stepIndex == 1 &&  
                      <Grid.Row columns={2}>
                        <Grid.Column textAlign='right'  mobile={16} tablet={16} computer={14}>
                             <Button color='blue' onClick={this.onStartExpenseAnalysis} disabled={!csvfile}><FormattedMessage id="scaninvoice.step1.boutton.next"
                                                                                                                 defaultMessage="NEXT: Start Invoice parsing"/></Button>
                        </Grid.Column>
                    </Grid.Row>}
                    {!loading && this.isPremiumUser() && stepIndex == 1 && 
                       <Grid.Row columns={2}>
                        <Grid.Column textAlign='center'  mobile={16} tablet={16} computer={14}> 
                            <Dropzone onDropAccepted={this.onDropAccepted.bind(this)}
                                      onDropRejected={this.onDropRejected.bind(this)}
                                      multiple = {false}
                                      maxSize={10485760} //10MB
                                      accept=".pdf,.png,.jpg"//, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                      disabled = {!supplierSelected} isDisabled = {!supplierSelected}
                                      >
                                {({getRootProps, getInputProps}) => (
                                       <section {...getRootProps()}
                                                style={{   'height': '200px',
                                                           'width': '100%',
                                                           'backgroundColor': '#f5f5f5',
                                                           'overflow': 'auto',
                                                           'text-align' : 'center'}}>
                                         {!supplierSelected &&
                                           <div  style={{ 'margin': '80px','opacity': '0.5'}}>
                                               <input {...getInputProps()}/>
                                               <Icon name='file alternate outline' size='big'/>
                                               {content}
                                        </div>}
                                        {supplierSelected &&
                                           <div  style={{ 'margin': '80px'}}>
                                               <input {...getInputProps()}/>
                                               <Icon name='file alternate outline' size='big'/>
                                               {content}
                                        </div>}
                                    </section>)}
                            </Dropzone>
                        </Grid.Column>
                    </Grid.Row> }
                   {!loading &&  !this.isPremiumUser() &&
                   <Grid.Row columns={1} /*style={{'overflow-x': 'auto'}}*/>
                        <Grid.Column /*width={14}*/  mobile={16} tablet={16} computer={14}> 
                            <Message fluid icon size='big' style={styles.FontLato12Bold} color='blue'>
                                                <Image src={img_performance} size ='small' rounded/>
                                                <br/>
                                                <Message.Content style={{marginLeft:'1em'}}>
                                                    <Message.Header color='black'>
                                                                        <FormattedMessage id="scaninvoice.premium.message.upgradeplan"
                                                                                            defaultMessage='PREMIUM Feature'/>
                                                     </Message.Header>
                                                      <br/>
                                                    <FormattedMessage id="scaninvoice.premium.title.message.upgradeplan"
                                                                    defaultMessage='Your current plan: '/>{' '}{membership && membership.name}   
                                                    <br/><br/>
                                                    <Button basic color='blue' style={styles.FontLato12Bold} onClick={(e) => this.upgradeSubscription()}>
                                                                        <FormattedMessage id="scaninvoice.premium.button.chooseplan"
                                                                                    defaultMessage='Choose premium plan'/>
                                                    </Button>                                   
                                                </Message.Content>
                            </Message>
                      </Grid.Column>
                    </Grid.Row>}  
 {/*                   {(stepIndex == 2 || stepIndex == 3) && 
                      <Grid.Row columns={1}>
                            <Grid.Column width={12}> 
                                <Message fluid /*style={styles.FontLato13Bold} warning icon>
                                    <Icon name='info circle'/>
                                    <Message.Content>
                                    <Message.Header><FormattedMessage id="scaninvoice.step2.message.header"
                                                              defaultMessage="Select the columns to consider or ignore."/>
                                    </Message.Header>
                                    <Message.List>
                                        <Message.Item>
                                            <FormattedMessage id="scaninvoice.step2.message.mandatory"
                                                              defaultMessage="Mandatory: Name, Price, Quantity, Unit."/>
                                        </Message.Item>
                                        <Message.Item>
                                            <FormattedMessage id="scaninvoice.step2.message.optional"
                                                              defaultMessage="Optional: Category, Supplier, Tax, Case units, Internal Code, Supplier Code, Note, Allergen, Storage, Expiration date, Batch number."/>
                                        </Message.Item>
//                                         <Message.Item>
                                            <FormattedMessage id="scaninvoice.step2.message.premium"
                                                              defaultMessage="Not subscribed users are limited to 10 ingredients imported."/>
                                        </Message.Item> //
                                    </Message.List>
                                    <br/>
                                    <Message.Header>
                                                    <FormattedMessage id="scaninvoice.step2.message.subheader1"
                                                              defaultMessage="All selected columns (not ignored) will be updated (even if the field/value is empty)."/>
                                    </Message.Header>
                                    <Message.Header>
                                                    <FormattedMessage id="scaninvoice.step2.message.subheader2"
                                                              defaultMessage="Ignored columns or other fields (not in the file) will be not be updated."/>
                                    </Message.Header>
                                    </Message.Content>
                                </Message>
                          </Grid.Column> 
                          <br/> <br/> 
                    </Grid.Row>}*/}
                    {stepIndex == 2 && items && items.length >0 && 
                    <Grid.Row columns={2}>
                        <Grid.Column textAlign='left'  mobile={12} tablet={12} computer={12}>
                              <Message /* style={styles.FontLato13Bold} */ warning size='large' icon>
                                   <Icon name='info circle'/>
                                    <Message.Content>
                                     <Message.List>  
                                        <Message.Item>
                                            <FormattedMessage id="scaninvoice.message.header.text.info2"
                                                            defaultMessage='Unselect useless line(s) if necessary'/>   
                                        </Message.Item>
                                        <Message.Item>
                                            <FormattedMessage id="scaninvoice.message.header.text.info1"
                                                            defaultMessage='Change proposed Action per item if necessary (double check/fix Orange/Red items)'/>   
                                        </Message.Item>
                                        <Message.Item>
                                            <FormattedMessage id="scaninvoice.message.header.text.info4"
                                                            defaultMessage='Modify the fields or fix any issue if necessary'/>   
                                        </Message.Item>
                                        <Message.Item>
                                            <FormattedMessage id="scaninvoice.message.header.text.info3"
                                                            defaultMessage='Add all items (or some) to stock if needed by selecting column [Add to stock]'/>   
                                        </Message.Item>
                                     </Message.List> 
                                    </Message.Content>
   
                            </Message>
                        </Grid.Column>
                    </Grid.Row>}
                    {stepIndex == 2 && 
                     <Grid.Row columns={2} style={{'overflow': 'auto'}}>
                        <Grid.Column textAlign='left' mobile={8} tablet={8} computer={7}>
                             <Button color='blue' onClick={(e)=>this.onSelect(e,1)}><FormattedMessage id="scaninvoice.step2.boutton.back"
                                                                                                       defaultMessage="BACK: Change your file"/></Button>
                        </Grid.Column>
                        <Grid.Column textAlign='right' mobile={8} tablet={8} computer={7}> 
                    {recipes && recipes.data && recipes.data.results && recipes.data.results.length > 0 && recipes.data.status =='SUCCEEDED' &&          
                            <Button color='blue' 
                                   disabled={selectionList && selectionList.length<=0 }
                                   onClick={(e)=> this.onValidateStep(e)}>
                                <FormattedMessage id="scaninvoice.step2.boutton.next"
                                                            defaultMessage="NEXT: Verify selection"/></Button>} 
{/*                         {recipes && recipes.data && recipes.data.results && recipes.data.results.status =='SUCCEEDED' &&  recipes.data.results.expenses.length > 0  &&     
                            <Button color='blue' 
                                    onClick={(e)=> this.loadIngredients(e)}
                                    disabled={selectionList && selectionList.length<=0 }>
                                         <FormattedMessage id="scaninvoice.step3.boutton.next"
                                                           defaultMessage="NEXT: Update ingredients"/></Button>}*/}
                        </Grid.Column> 
                    </Grid.Row>}
                    {stepIndex == 2 && recipes && recipes.request_done &&  items && items.length == 0 && 
                    <Grid.Row columns={2}>
                        <Grid.Column textAlign='left'  mobile={12} tablet={12} computer={12}>
                                 <Message warning>
                                 <FormattedMessage id="scaninvoice.step2.loading.invalid.file"
                                                  defaultMessage="No consistent data in this file, please choose a valid expense/invoice file."/>
                                 </Message>
                        </Grid.Column>
                    </Grid.Row>}
                    {stepIndex == 2 && 
                    <Grid.Row columns={1} style={{'overflow': 'auto'}}>
                        <Grid.Column /*width={14}*/  mobile={16} tablet={16} computer={14} > 
                           <Dimmer.Dimmable >
                                <Dimmer active={recipes && (!recipes.request_done && !recipes.error)} blurring inverted>
                                    <Loader inverted content={<FormattedMessage id="scaninvoice.step2.loading.message"
                                                                             defaultMessage='Analyzing the current document (multiple pages take more time)'/>}
                                                  size='large' />      
                                </Dimmer> 
                             {recipes && recipes.error &&
                                 <div>
{/*                                 <Message error size='small'>
                                    <Message.Header>
                                     <FormattedMessage id="scaninvoice.error.title.message.maxusage"
                                                        defaultMessage=' You have reached the maximum of pages to scan for this period'/>
                                     </Message.Header>
                                     <Message.Content>
                                         {recipes.error.message}
                                     </Message.Content>
                                   </Message>  */}
                                <Message fluid icon size='big' style={styles.FontLato12Bold} color='blue'>
                                    <Image src={img_performance} size ='small' rounded/>
                                    <br/>
                                    <Message.Content style={{marginLeft:'1em'}}>
                                        <Message.Header color='black'>
                                            <FormattedMessage id="scaninvoice.premium.message.upgradeplan"
                                                                defaultMessage='PREMIUM Feature'/>
                                        </Message.Header>
                                         <Message.Content>
                                          {/*  {recipes.error.message} */}
                                          <FormattedMessage id="scaninvoice.error.title.message.maxusage"
                                                            defaultMessage=' You have reached the maximum of pages to scan for this period'/>
                                        </Message.Content>
                                        <br/>
                                        <FormattedMessage id="scaninvoice.premium.title.message.upgradeplan"
                                                        defaultMessage='Your current plan: '/>{' '}{membership && membership.name}   
                                        <br/><br/>
                                        <Button basic color='blue' style={styles.FontLato12Bold} onClick={(e) => this.upgradeSubscription()}>
                                            <FormattedMessage id="scaninvoice.premium.button.chooseplan"
                                                        defaultMessage='Choose premium plan'/>
                                        </Button>                                      
                                    </Message.Content>
                                </Message>
                                </div>
                             }
                             {recipes && !recipes.request_done &&
                               <div> <br/> <br/> <br/> <br/><br/></div>}
                             <br/> 
                             {items && items.length >0 && supplierSelected &&
                                    <Label>{supplierSelected.name}{' '}&nbsp;{' '}
                                        <Label.Detail>{' '}{documentNumberPages} Page(s) </Label.Detail>
                                     </Label>
                              }
                              <br/>
                              {items && items.length >0 && 
                                    <Table //selectable  
                                            unstackable 
                                            compact 
                                            striped 
                                            singleLine 
                                            style={styles.FontLato12}>
                                            <Table.Header>
                                                <Table.Row>
                                                 {this.addExpenseColumns(items)}
                                                </Table.Row>
                                            </Table.Header>   
                                            <Table.Body>
                                                { items && items.length >0 && 
                                                 this.addExpenseRows(items)
                                                }
                                            </Table.Body>
                                    </Table>}
                               <br/>
                             </Dimmer.Dimmable>
                        </Grid.Column>
                    </Grid.Row>}
                   
                    {stepIndex == 2 && 
                    <Grid.Row columns={3}>
                           {items && items.length >0 && 
                            <Grid.Column textAlign='left'>
                                  <span><Menu compact secondary centered style={styles.FontLato12}>
                                         <Dropdown defaultValue={20} 
                                                  options={options} 
                                                  item
                                                  inline
                                                  fluid
                                                  onChange={this.onElemPerPageChange}
                                                  />
                                  </Menu>&ensp;{begin+1} <FormattedMessage id="scaninvoice.pagination.to"
                                                              defaultMessage='to'/> {end} <FormattedMessage id="scaninvoice.pagination.over"
                                                              defaultMessage='of'/> {length}</span>
                                </Grid.Column>}
                             {items && items.length >0 && 
                                <Grid.Column textAlign='center'>
                                    <Pagination color='blue'   
                                        secondary
                                        activePage={page}
                                        totalPages={totalPages}
                                        siblingRange={4}
                                        boundaryRange ={0}
                                        //defaultActivePage={10}
                                        ellipsisItem={{ content: <Icon name='ellipsis horizontal' size='small'/>, icon: true }}
                                        //ellipsisItem={null}
                                        firstItem = {null} 
                                        lastItem = {null}
                                        onPageChange={this.setPageNum}
                                        size='small'
                                    />
                                </Grid.Column>}
                    </Grid.Row> }
                    {stepIndex == 3 && 
                     <Grid.Row columns={3} style={{'overflow': 'auto'}}>
                        <Grid.Column textAlign='left' mobile={8} tablet={8} computer={7}>
                             <Button color='blue' onClick={(e)=>this.onSelect(e,2)}><FormattedMessage id="scaninvoice.step3.boutton.back"
                                                                                                       defaultMessage="BACK: Modify selection"/></Button>
                        </Grid.Column>
                        <Grid.Column textAlign='right' mobile={8} tablet={8} computer={7}> 
                        {recipes && recipes.data && recipes.data.results &&  recipes.data.results.length > 0  &&  recipes.data.status =='SUCCEEDED' &&    
                            <Button color='blue' 
                                    onClick={(e)=> this.loadIngredients(e)}
                                    disabled={selectionList && selectionList.length<=0 }>
                                        <FormattedMessage id="scaninvoice.step3.boutton.next"
                                                         defaultMessage="NEXT: Update ingredients"/></Button>}
                        </Grid.Column>
                    </Grid.Row>}
                    {stepIndex == 3 && 
                    <Grid.Row columns={1} style={{'overflow': 'auto'}}>
                        <Grid.Column /*width={14}*/  mobile={16} tablet={16} computer={14} > 
                             {items && items.length >0 && supplierSelected &&
                                    <Label>{supplierSelected.name}{' '}&nbsp;{' '}
                                        <Label.Detail>{' '}{documentNumberPages} Page(s) </Label.Detail>
                                     </Label>
                                }
                                <br/> 
                                 {selectionList && selectionList.length >0 &&          
                                    <Table //selectable  
                                            unstackable 
                                            compact 
                                            striped 
                                            singleLine 
                                            style={styles.FontLato11} >
                                            <Table.Header>
                                                <Table.Row>
                                                 {this.addExpenseColumns(selectionList,0)}
                                                </Table.Row>
                                            </Table.Header>   
                                            <Table.Body>
                                                {this.addExpenseRows(selectionList,0)}
                                            </Table.Body>
                                    </Table>}
                                <br/> 
                        </Grid.Column>
                    </Grid.Row>}
                    {stepIndex == 3 && 
                    <Grid.Row columns={3}>
                        {items && items.length >0 &&     
                            <Grid.Column textAlign='left'>
                                  <span><Menu compact secondary centered style={styles.FontLato12}>
                                         <Dropdown defaultValue={20} 
                                                  options={options} 
                                                  item
                                                  inline
                                                  fluid
                                                  onChange={this.onElemPerPageChange}
                                                  />
                                  </Menu>&ensp;{begin+1} <FormattedMessage id="scaninvoice.pagination.to"
                                                              defaultMessage='to'/> {end} <FormattedMessage id="scaninvoice.pagination.over"
                                                              defaultMessage='of'/> {length}</span>
                                </Grid.Column>}
                            {items && items.length >0 &&     
                                <Grid.Column textAlign='center'>
                                    <Pagination color='blue'   
                                        secondary
                                        activePage={page}
                                        totalPages={totalPages}
                                        siblingRange={4}
                                        boundaryRange ={0}
                                        //defaultActivePage={10}
                                        ellipsisItem={{ content: <Icon name='ellipsis horizontal' size='small'/>, icon: true }}
                                        //ellipsisItem={null}
                                        firstItem = {null} 
                                        lastItem = {null}
                                        onPageChange={this.setPageNum}
                                        size='small'
                                    />
                                </Grid.Column>}
                    </Grid.Row> } 
                    <Grid.Row columns={1}/>  
                    {stepIndex == 4 &&  ingredients &&
                     <Grid.Row columns={3} >
                            <Dimmer active={adding} inverted>
                                <Loader indeterminate><FormattedMessage id="scaninvoice.step4.result.loading.text"
                                                                        defaultMessage='Update ongoing ...'/></Loader>
                            </Dimmer>
                            <Grid.Column textAlign='left'  mobile={10} tablet={10} computer={10}>
                               {!adding && ingredients.items && ingredients.items.length > 0 &&
                                    <Message icon fluid style={styles.FontLato13Bold}>
                                        <Icon name='thumbs up outline' size='small'/>
                                        <Message.Content>
                                            <Message.Header>
                                                <FormattedMessage id="scaninvoice.step4.result.success.header"
                                                                defaultMessage="Update done"/>
                                            </Message.Header>
                                            <Message.List>
                                                <Message.Item>
                                                    {ingredients.items[0].creates.length}&nbsp;
                                                    <FormattedMessage id="scaninvoice.step4.result.success.status.creates"
                                                                    defaultMessage="elements created with success."/>
                                                    </Message.Item>
                                                    <Message.Item>
                                                     {ingredients.items[0].updates.length}&nbsp;
                                                    <FormattedMessage id="scaninvoice.step4.result.success.status.updates"
                                                                    defaultMessage="elements updated with success."/>
                                                </Message.Item>
{/*                                                 {!this.isPremiumUser() &&
                                                <Message.Item>
                                                    <FormattedMessage id="scaninvoice.step4.result.success.premium"
                                                                    defaultMessage="Your are limited to 15 ingredients"/>
                                                </Message.Item>} */}
                                            </Message.List>
                                        </Message.Content>
                                    </Message>
                               }
{/*                               {!adding && (!ingredients.items || ingredients.items[0].length == 0 ) &&
                                <Message icon fluid style={styles.FontLato13Bold}>
                                    <Icon name='redo' size='small'/>
                                    <Message.Content>
                                        <Message.Header>
                                                <FormattedMessage id="scaninvoice.step4.result.error.header"
                                                                defaultMessage="Oops something happened"/>
                                        </Message.Header>
                                        <Message.List>
                                                <Message.Item>
                                                    <FormattedMessage id="scaninvoice.step4.result.error.message"
                                                        defaultMessage="No element created (check your file and retry)."/>
                                                </Message.Item>
                                                {!this.isPremiumUser() &&
                                                <Message.Item>
                                                    <FormattedMessage id="scaninvoice.step4.result.success.premium"
                                                                    defaultMessage="Your are limited to 15 ingredients"/>
                                                </Message.Item>}
                                        </Message.List>
                                    </Message.Content>
                               </Message>
                               }
                               {!adding && !this.isPremiumUser() && 
                                    <Message fluid icon size='big' style={styles.FontLato12Bold} color='blue'>
                                        <Image src={img_performance} size ='small' rounded/>
                                        <br/>
                                        <Message.Content style={{marginLeft:'1em'}}>
                                            <Message.Header color='black'>
                                                                <FormattedMessage id="scaninvoice.premium.message.upgradeplan"
                                                                                    defaultMessage='PREMIUM Feature'/>
                                            </Message.Header>
                                            <br/>
                                            <Button basic color='blue' style={styles.FontLato12Bold} onClick={(e) => this.upgradeSubscription()}>
                                                                <FormattedMessage id="scaninvoice.premium.button.chooseplan"
                                                                            defaultMessage='Choose premium plan'/>
                                            </Button>                                      
                                        </Message.Content>
                                    </Message>} */}
                            </Grid.Column>
                     </Grid.Row>}
                </Grid>
            </div>
            {alert.message && toaster_dispatch(dispatch,alert,intl)}
        </SideLeftUncoverIngredients>
      );
    }
  }
  


  function mapStateToProps(state) {
    const { dispatch, alert,ingredients,recipes,supplier } = state;
    const { subscription,customer,loading } = state.payment;
    const { adding } = state.ingredients;
    return {
        ingredients,
        supplier,
        recipes,
        adding,
        subscription,
        customer,
        loading,
        dispatch,
        alert,
    };
  }
  
  
  const connectedScanInvoice = injectIntl(connect(mapStateToProps)(ScanInvoice));
  export { connectedScanInvoice as ScanInvoice };


 